module.exports = __webpack_public_path__ + "assets/img/help_image01-3.904094ed.png";